<ng-container *ngIf="dataStream$ | async as data">
    <div
        class="purchase-payment"
        appLinkify
        [linkConfigPath]="i18nBasePath + '.linkConfigs'">
        <div class="steps-content">
            <div
                nz-row
                nzGutter="30"
                class="purchase__row">
                <div
                    nz-col
                    nzXs="12"
                    class="purchase__info">
                    <div
                        class="purchase__heading"
                        [innerHTML]="wts?.getI18nLabel(i18nBasePath, 'title') | sanitizeHtml"></div>

                    <ul class="purchase-checklist">
                        <li class="purchase-checklist__item">
                            <svg-icon-sprite
                                class="purchase-checklist__icon"
                                src="done"></svg-icon-sprite>
                            {{ wts?.getI18nLabel(i18nBasePath, 'checklist.accountVerified') }}
                        </li>

                        <li class="purchase-checklist__item">
                            <svg-icon-sprite
                                class="purchase-checklist__icon"
                                src="done"></svg-icon-sprite>
                            {{ wts?.getI18nLabel(i18nBasePath, 'checklist.documentSigned') }}
                        </li>

                        <li
                            *ngIf="paymentMethodAdded"
                            class="purchase-checklist__item">
                            <svg-icon-sprite
                                class="purchase-checklist__icon"
                                src="done"></svg-icon-sprite>
                            {{ wts?.getI18nLabel(i18nBasePath, 'checklist.paymentMethodAdded') }}
                        </li>
                    </ul>

                    <app-purchase-methods
                        [initData]="initData"
                        [isPurchaseAboveLimit]="isPurchaseAboveLimit"
                        [config]="config"
                        (updateSubmitBtnDisableStatus)="onUpdateSubmitBtnDisableStatus($event)"
                        (paymentMethodAdded)="paymentMethodAdded = $event"></app-purchase-methods>
                </div>

                <div
                    nz-col
                    nzXs="12"
                    class="purchase__summary">
                    <app-summary
                        [frequency]="frequency"
                        [entity]="cart$ | async"
                        [numberOfShares]="numberOfShares$ | async"
                        [purchaseStart]="purchaseStart$ | async"
                        [withImage]="!data.recurring"></app-summary>
                </div>
            </div>
        </div>

        <div
            nz-row
            nzGutter="30"
            class="purchase__row">
            <div
                nz-col
                nzXs="12"
                class="purchase__info">
                <form
                    nz-form
                    nzLayout="vertical"
                    [formGroup]="paymentConsentForm"
                    #paymentFormEl>
                    <div class="steps-action-with-header">
                        <div class="steps-note">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="wts?.getI18nLabel(i18nBasePath, 'authorization.validators.required')">
                                    <nz-checkbox-wrapper class="steps-checkbox">
                                        <label
                                            nz-checkbox
                                            formControlName="authorizationProvided"
                                            id="authorizationProvided"></label>

                                        <span
                                            class="steps-checkbox__desc steps-checkbox__desc-consent"
                                            [innerHTML]="wts?.getI18nLabel(i18nBasePath, 'authorization.descr') | sanitizeHtml"
                                            (click)="acceptConsent($event)"></span>
                                    </nz-checkbox-wrapper>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <div class="steps-action">
                            <button
                                nz-button
                                nzSize="large"
                                nzType="primary"
                                type="submit"
                                (click)="onFormSubmit(paymentFormEl, data.purchaseStart, data.entity.offeringId, data.recurring)"
                                [disabled]="isSubmitBtnDisabled"
                                [nzLoading]="loader.isLoading$ | async">
                                {{ wts.getI18nLabel(i18nBasePath, 'actions.submit') }}
                            </button>

                            <button
                                nz-button
                                nzSize="large"
                                nzType="default"
                                (click)="onBackClick(data.purchaseStart)"
                                [innerHTML]="wts?.getI18nLabel(i18nBasePath, 'actions.back') | sanitizeHtml"></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-container>
